import { Pipe, PipeTransform } from '@angular/core';
import { DiscrepancyUnits } from '@app/shared/models/business-model/delivery-note-discrepancies';
import { StorageService } from '@app/core/services/client-services/storage-service/storage.service';

@Pipe({ name: 'humanReadableDiscrepancyUnits', })
export class TranslateDiscrepancyUnitsPipe implements PipeTransform {
    discrepancyUnits: DiscrepancyUnits[];

    constructor(private storageService: StorageService) {
        this.discrepancyUnits =
            this.storageService.getItemAsObject('discrepancyUnits');
    }

    transform(unitId: number): string {
        if (unitId) {
            return this.discrepancyUnits.filter(r => r.unitId === unitId)[0]
                .name;
        }
        return '';
    }
}
